<template>
    <div class="brt-bottomQuick-Module">
        <div class="wrap">

            <div class="l" @click.stop="selected(1)">
                <i class="iconfont icon-zhoubian"></i>
                <span>附近设施</span>
            </div>

            <div class="c">
                <div class="wrap" @click.stop="selected(2)">
                    <div class="content">
                        <i class="iconfont icon-route_01"></i>
                        <span>路线</span>
                    </div>
                </div>
            </div>

            <div class="r" @click.stop="selected(3)">
                <i class="iconfont icon-tuijian1"></i>
                <span>推荐展区</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        name: "BottomQuickModule",
        data(){
            return {

            }
        },

        computed:{
            ...mapState({
                brtmap:state=>state.mapStore.brtmap,
                publicFormat:state=>state.RecommendData.publicFormat,
            })
        },

        methods:{
            selected(n){
                switch (n){
                    case 0:break;
                    case 1:
                        // console.log('周边设施');
                        if(!this.publicFormat.length){
                            this.$message.info('暂无附近设施推荐');
                            return;
                        }

                        this.brtmap.guideView = false;

                        break;
                    case 2:

                        // console.log('起点规划');
                        this.$mapStep.type = 'planRoute';
                        this.$BRT.$route.enterType ='directRoute';
                        this.bus.$emit('startAndEnd', {type: 2});
                        break;

                    case 3:

                        // console.log('推荐展区');
                        this.$router.push('/search');
                        break;
                    default:break;
                }
            }
        }
    }
</script>

<style lang="less">

    @import "../../../../../styles/cssBlock.less";

    .brt-bottomQuick-Module{
        padding: 0px @130px;
        color: @fontColorA2;
        font-size: @24px;
        >.wrap{
            display: flex;
            justify-content: space-between;
            align-items: center;
            @var:@120px;
            height:@var;
            line-height:@var;
            border-radius:@var/2;
            box-shadow: @shadowbox;
            margin-bottom: @standartHeightA4;
            background-color: @themeReverseColor;
            pointer-events: auto;

            >div{
                display: flex;
                flex-direction: column;
                text-align: center;
                line-height: 1.2;
                >i{
                    font-size: @50px;
                    color: @themeColor;
                }


                &.l,&.r{
                    flex: 1;
                    &:active{opacity: .8}
                }

                &.c{
                    position: relative;
                    &:before{
                        content: "";
                        display: inline-block;
                        @var1:@150px;
                        width: @var1;
                        height: @var1;
                        border-radius: @var1/2;
                        background-color: @themeReverseColor;
                        position: absolute;
                        left:-( @var1 - @var)/2;
                        top: -( @var1 - @var)/2;
                        z-index: 1;
                    }
                    &:after{
                        content: "";
                        display: inline-block;
                        @var1:@150px;
                        width: @var1;
                        height: @var1;
                        border-radius: @var1/2;
                        background-color: @themeReverseColor;
                        box-shadow: @shadowbox;
                        position: absolute;
                        left:-( @var1 - @var)/2;
                        top: -( @var1 - @var)/2;
                        z-index: -1;
                    }
                    >.wrap{
                        width: @var;
                        height: @var;
                        flex-shrink: 0;
                        border-radius: @var/2;
                        background-color: @themeColor;
                        color: @themeReverseColor;
                        box-shadow: 0px 0px @15px @themeShowdowColor;
                        z-index: 2;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        &:active{opacity: .8}
                        >.content{
                            display: flex;
                            flex-direction: column;
                            text-align: center;
                            line-height: 1.2;
                            >i{
                                font-size: @50px;
                                color: @themeReverseColor;
                            }
                        }
                    }

                }
            }
        }

    }


</style>
